import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i4.14
import React from 'react';
import IconWrap from '../../IconWrap';
const Pin = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M19.826 10.514c.2.203.199.531-.005.732-.68.593-1.915.466-3.222-.227l-2.52 3.85c.609 1.458.611 2.826-.116 3.649a.69.69 0 01-.891.078l-.089-.075-3.045-3.045-4.181 4.182a1 1 0 11-1.414-1.414l4.18-4.183-3.13-3.13a.572.572 0 01-.06-.738l.06-.07c.81-.81 2.219-.833 3.725-.207l3.873-2.498c-.689-1.29-.827-2.51-.267-3.201l.094-.105.06-.05a.429.429 0 01.477-.006l.069.056 6.402 6.402z"
    })));
Pin.displayName = 'Pin';
export default Pin;
